<template>
    <div class="input-wrapper">
        <div class="input-name">
            {{inputName}}
        </div>
        <div
            class="valueField"
        >
            <input type="text" :value="currentValue" @input="completeInputs">
            <div
                class="values"
                v-if="isSelectorOpen"
            >
                <div class="selectorItems"
                     v-for="(item, index) in selectorValues"
                     :key='index'
                     @click.stop="emitValue($event, item)"
                >
                    {{getText(item)}}
                </div>
            </div>
        </div>
<!--        <input type="text" :value="currentValue" @input="emitValue">-->
    </div>
</template>

<script>
import debounce from '../../../tools/debounce';


export default {
    name: 'AutoCompleteUserSearch',
    data: () => ({
        currentValue: '',
        isSelectorOpen: false,
    }),
    methods: {
        completeInputs: debounce(function(e){
            this.moka(e);
        }, 1000),

        emitValue(e, item){
            this.isSelectorOpen = false;

            if (this.getText(item) == this.currentValue) {
                this.isSelectorOpen = false;
                return;
            }
            this.currentValue = this.getText(item);
            this.isSelectorOpen = false;
            this.$emit('autocomplete-item-click', {
                value: item,
            });
        },

        moka(e) {
            if(e.target.value == '') {
                this.isSelectorOpen = false;
                return;
            }
            this.isSelectorOpen = true;
            this.currentValue = e.target.value;
            this.$emit('debounce-end', {
                value: e.target.value,
            });
        },

        getText(obj) {
            let text='';
            if (!obj) return;
            for (let i = 0; i < this.vizKey.length; i++) {
                text += obj[this.vizKey[i]] + ' ';
            }
            return text;
        },
    },
    mounted() {
        this.currentValue = this.getText(this.inputValue);
    },
    watch: {
        inputValue: {
            handler: function (newV) {
                this.currentValue = this.getText(newV);
            },
        },
    },
    props: {
        inputName: String,
        inputValue: Object,
        vizKey: Array,
        selectorValues: Array,
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    @mixin custom-scroll-bar {
        &::-webkit-scrollbar {
            height: auto;
            width: 0.3rem;
        }

        &::-webkit-scrollbar-thumb {
            background: #E1E1E1;
            border-radius: 0.3rem;
        }

        &::-webkit-scrollbar-track {
            background: none;
        }
    }

    .input-wrapper {
        cursor: pointer;
        border-radius: 0.2rem;
        border: rem(1) solid #98A0A9;
        width: 100%;
        height: 2.5rem;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;

        .input-name {
            position: absolute;
            top: -0.4rem;
            left: 0.5rem;
            background: white;
            padding-left: 0.3rem;
            padding-right: 0.3rem;
            font-size: 0.6rem;
            font-weight: 600;
            color: #98A0A9;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }

        input{
            border: none;
            display: block;
            height: 100%;
            width: 100%;
            background: none;
            font-size: 0.8rem;
        }

        .valueField {
            border: none;
            display: flex;
            height: 100%;
            width: 100%;
            background: none;
            padding-left: 0.8rem;
            padding-right: 0.8rem;
            font-size: 0.8rem;
            position: relative;
            align-items: center;

            .values {
                position: absolute;
                top: 2.3rem;
                left: calc(0rem - 1px);
                width: 100%;
                z-index: 5;
                background: white;
                border-right: rem(1) solid #98A0A9;
                border-left: rem(1) solid #98A0A9;
                border-bottom: rem(1) solid #98A0A9;
                border-radius: 0.2rem;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                box-sizing: content-box;
                max-height: 20rem;
                overflow-y: scroll;
                @include custom-scroll-bar;

                .selectorItems {
                    width: 100%;
                    height: auto;
                    display: flex;
                    padding-top: 0.3rem;
                    padding-bottom: 0.3rem;
                    padding-left: 0.8rem;
                    margin-top: 0.2rem;
                    margin-bottom: 0.2rem;
                    padding-right: 0.8rem;
                    align-items: center;

                    &:hover{
                        background: #8DB3C8;
                    }
                }
            }
        }
    }

    @import "../../../styles/variables";
    @media (max-width: $vm) {
        .input-wrapper {
            cursor: pointer;
            border-radius: 0.2rem;
            border: mrem(1) solid #98A0A9;
            width: 100%;
            height: mrem(35);
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;

            .input-name {
                position: absolute;
                top: -10px;
                left: mrem(20);
                background: white;
                padding-left: 0.3rem;
                padding-right: 0.3rem;
                font-size: mrem(14);
                font-weight: 600;
                color: #98A0A9;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
            }

            input{
                border: none;
                display: block;
                height: 100%;
                width: 100%;
                background: none;
                font-size: mrem(12);
            }

            .valueField {
                border: none;
                display: flex;
                height: 100%;
                width: 100%;
                background: none;
                padding-left: 0.8rem;
                padding-right: 0.8rem;
                font-size: mrem(12);
                position: relative;
                align-items: center;

                .values {
                    position: absolute;
                    top: mrem(35);
                    left: calc(0rem - 1px);
                    width: 100%;
                    z-index: 5;
                    background: white;
                    border-right: mrem(1) solid #98A0A9;
                    border-left: mrem(1) solid #98A0A9;
                    border-bottom: mrem(1) solid #98A0A9;
                    border-radius: 0.2rem;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                    box-sizing: content-box;
                    max-height: mrem(250);
                    overflow-y: scroll;
                    @include custom-scroll-bar;

                    .selectorItems {
                        width: 100%;
                        height: auto;
                        display: flex;
                        padding-top: mrem(7);
                        padding-bottom: mrem(7);
                        padding-left: mrem(4);
                        margin-top: 0.2rem;
                        margin-bottom: 0.2rem;
                        padding-right: mrem(4);
                        align-items: center;

                        &:hover{
                            background: #8DB3C8;
                        }
                    }
                }
            }
        }
    }
</style>